import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { immunizationQKeys } from "@hooks/queries/immunization/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  immunization: FormData;
  immunizationId: string;
  patientId: string;
}

export const useUpdateImmunization = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ immunization, immunizationId }: MutationProps) => {
      return api.patch(`preventative/${immunizationId}`, immunization, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (res, variables) => {
      showSuccessNotification({
        title: "success",
        message: "update-immunization-success",
      });
      queryClient.invalidateQueries({
        queryKey: immunizationQKeys.patient(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Immunization]", res);
      handleErrors(res, "mutation");
    },
  });
};
